module.exports = __webpack_public_path__ + "img/bank-js.33e25553.png";